import apiClient from './apiClient';

/**
 * Get candidate journey milestones and progress
 * @param {number} companyId - Company ID
 * @returns {Promise} - Journey data with all stages
 */
export const getJourneyData = async (companyId) => {
  try {
    const response = await apiClient.get('/journey/candidate', {
      params: { companyId },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Claim initial gift reward (Stage 4)
 * @param {number} companyId - Company ID
 * @returns {Promise} - Claim response
 */
export const claimInitialGift = async (companyId) => {
  try {
    const response = await apiClient.post('/journey/claim-initial-gift', {
      companyId,
      initialCardSet: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Claim final gift reward (Stage 7)
 * @param {number} companyId - Company ID
 * @returns {Promise} - Claim response
 */
export const claimFinalGift = async (companyId) => {
  try {
    const response = await apiClient.post('/journey/claim-final-gift', {
      companyId,
      finalCardSet: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Update delivery address for gift claim
 * @param {number} companyId - Company ID
 * @param {Object} addressData - Address details
 * @returns {Promise} - Update response
 */
export const updateDeliveryAddress = async (companyId, addressData) => {
  try {
    const response = await apiClient.post('/journey/update-address', {
      companyId,
      ...addressData,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
